import { Stack } from '@mui/material';
import { NextPrevButton } from 'Components';
import { AlternativeMedicineContext } from 'Context/AlternativeMedicine';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { LightBlueX } from 'Images';
import { handleBackNavigation } from 'Utils/reimbursements';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

interface IBackButton {
  isExitBtn?: boolean;
}

export const BackButton = ({ isExitBtn }: IBackButton) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Reimbursements);
  const isDesktop = useIsDesktop();

  const contextValues = useContext(AlternativeMedicineContext);

  const navigate = useNavigate();

  const handleBack = () => {
    handleBackNavigation({
      isExitBtn,
      navigate,
      context: contextValues,
    });
  };

  return (
    <Stack
      sx={
        isExitBtn
          ? { width: isDesktop ? 'fit-content' : '100%' }
          : { alignItems: 'center', mt: 4 }
      }
    >
      <NextPrevButton
        callback={handleBack}
        text={isExitBtn ? dictionary.exit : dictionary.back}
        style={
          isDesktop
            ? undefined
            : {
                button: { height: '36px', width: '100%' },
                text: {
                  fontSize: '16px',
                  fontWeight: isExitBtn ? '600' : '700',
                },
              }
        }
        hideArrowIcon={isExitBtn}
        icon={
          isExitBtn
            ? {
                src: LightBlueX,
                sx: { width: '24px', height: '24px', top: '1px' },
              }
            : undefined
        }
      />
    </Stack>
  );
};
